import React, { useEffect, useState} from "react";
import Head from "../Header/head";
import "../avatar/avatar.css";
import "../../common/css/common.css";
import {useForm} from "react-hook-form";
import { useNavigate,useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getAvatar,createAvatar,changeGender,updateAvatar} from "../../redux/actions/avatar_action";

function CreateAvatar(){
    const location = useLocation();
    const joined_as = location.state.joined_as;
    const debate_id = location.state.debate_id;
    const room_id = location.state.room_id;
    const code = location.state.code;

    const skin_color_obj = {"skin-1":"skin-color-1.png","skin-2":"skin-color-2.png","skin-3":"skin-color-3.png"}
    const male_hair_color_obj = {"hair-1":"male-hair-color-1.png","hair-2":"male-hair-color-2.png","hair-3":"male-hair-color-3.png","hair-4":"male-hair-color-4.png"}
    const female_hair_color_obj = {"hair-5":"female-hair-color-1.png","hair-6":"female-hair-color-2.png","hair-7":"female-hair-color-3.png","hair-8":"female-hair-color-4.png"}
    const [dress,useDress] = useState({});
    
    // const dress = {"dress-1":"clothe-color-1.png","dress-2":"clothe-color-2.png","dress-3":"clothe-color-3.png","dress-4":"clothe-color-4.png"}
    // const dress_2 = {"dress-1":"mediator-clothe-color-1.png","dress-2":"mediator-clothe-color-2.png","dress-3":"mediator-clothe-color-3.png","dress-4":"mediator-clothe-color-4.png"}

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const auth = useSelector((state)=>state.jwtAuthreducer);


    useEffect(()=>{  
        console.log("from avatar ======")
        return () => {
            dispatch(getAvatar());
            {joined_as === "mediator" ? useDress({"dress-1":"mediator-clothe-color-1.png","dress-2":"mediator-clothe-color-2.png","dress-3":"mediator-clothe-color-3.png","dress-4":"mediator-clothe-color-4.png"}):useDress({"dress-1":"clothe-color-1.png","dress-2":"clothe-color-2.png","dress-3":"clothe-color-3.png","dress-4":"clothe-color-4.png"})}

        }
        
    },[])
    
    // State used in this component
    const [maleHair,setMaleHair]=useState();
    const [skin,setSkin]=useState();
    const [dress_color,setDresscolor]=useState();
    const [femaleHair,setfemaleHair]=useState();
    // 
   
    const avatar = useSelector((state)=>state.avatarReducer);
    
    const {
        handleSubmit,
        register,
        formState: { errors, isSubmitting},
    }=useForm();

    const onSubmit = async(values)=>{

        if(avatar.profile_exist){
            Object.keys(values).forEach(key => {
                if (values[key] == null) {
                    values[key]=avatar[key];
                }
            });
            try{
                dispatch(updateAvatar(values));
                {joined_as === "mediator" ? navigate("/debates",{replace: true}):navigate("/choose",{state:{joined_as:'participant',debate_id:debate_id,room_id:room_id,code:code}})};
            }
            catch(err){
                throw(err)
            }

        }
        else{
            try{
                dispatch(createAvatar(values));
                {joined_as === "mediator" ? navigate("/debates",{replace: true}):navigate("/choose",{state:{joined_as:'participant',debate_id:debate_id,room_id:room_id,code:code}})};
            }
            catch(err){
                throw(err)
            }
        }
        

    }

    let updateAvatarMaleHair=(index)=>{
        setMaleHair(index);
    }

    let updateAvatarFemaleHair=(index)=>{
        setfemaleHair(index);
    }
    let updateAvatarSkin=(index)=>{
        setSkin(index);
    }
    let updateAvatarDress=(index)=>{
        setDresscolor(index);
    }
    let selectedGender=(gender)=>{
        dispatch(changeGender(gender))
       
    }
   
    return (
        <>
        {auth.isAuthenticated === false ?
            navigate("/login")
            :
        <div>
        <Head/>

        <div className="inner-page-wrapper">
            <div className="step-header">
                <div className="container d-flex">
                    <div className="step-header-title">
                        Get Started
                    </div>

                    <div className="step-header-text">
                        <span>Step 1:</span> Start creating your avatar
                    </div>
                </div>
            </div>

        <div className="form-step step1">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6">
                        {/* <div className="custom-control custom-switch">
                            
                            <input type="checkbox" className="custom-control-input" id="customSwitches" />

                          <label className="custom-control-label" htmlFor="customSwitches"><b>Upload Picture As Avatar</b></label>
                        </div> */}
                        <form action="" method="POST" onSubmit={handleSubmit(onSubmit)}>
                            <div>
                                <div className="form-step-row first">
                                    <div className="form-row-left">
                                        <label>Choose Gender</label>
                                    </div>

                                    <div className="form-row-right">
                                        <input type="hidden" name="selected_gender" id="selected_gender"/>
                                        <div className="radio-input mr-2">
                                            {avatar.gender==="male"
                                            ?
                                            <input checked type="radio" id="male" name="gender" value="male" onClick={()=>selectedGender("male")}   {...register("gender")}/>
                                            :
                                            <input  type="radio" id="male" name="gender" value="male" onClick={()=>selectedGender("male")}   {...register("gender")}/>
                                            }
                                            <label htmlFor="male">Male</label>
                                        </div>

                                        <div className="radio-input">
                                            {avatar.gender === "female"
                                            ?
                                            <input checked type="radio" id="female" name="gender" value="female"  onClick={()=>selectedGender("female")}  {...register("gender")} />
                                            :
                                            <input type="radio" id="female" name="gender" value="female"  onClick={()=>selectedGender("female")}  {...register("gender")} />
                                            }
                                            <label htmlFor="female">Female</label>
                                        </div>
                                    </div>
                                </div>

                                <div className="form-step-row">
                                    <div className="form-row-left">
                                        <label>Choose Tone</label>
                                    </div>

                                    <div className="form-row-right color-options">
                                        {Object.keys(skin_color_obj).map((key,index) => (
                                        <div className="radio-tick mr-3 selected" key={index}>
                                            {avatar.skin_tone === key 
                                            ?
                                            <input  type="radio" id={index} name="skin_tone" value={key}  onClick={()=>updateAvatarSkin(key)}  {...register("skin_tone")}  />
                                            :
                                            <input  type="radio" id={index} name="skin_tone" value={key}  onClick={()=>updateAvatarSkin(key)}  {...register("skin_tone")}  />

                                            }
                                            <label htmlFor={index}>
                                                <img src={process.env.PUBLIC_URL +  `img/${skin_color_obj[key]}` } width="42" alt="" title=""  />
                                            </label>
                                        </div>
                                        ))}


                                    </div>
                                </div>

                                <div className="form-step-row">
                                    <div className="form-row-left">
                                        <label>Choose Hair</label>
                                    </div>
                                    {avatar.gender === "male" ?
                                    <div className="form-row-right hairs-color color-options" >
                                        {Object.keys(male_hair_color_obj).map((key,index)=>(
                                            <div className="radio-tick" key={index}>
                                                {avatar.hair_color === key
                                                ?
                                                <input  type="radio" id={`male[${index}]`} name="hair_color" value={key}  onClick={()=>updateAvatarMaleHair(key)} {...register("hair_color")} />
                                                :
                                                <input  type="radio" id={`male[${index}]`} name="hair_color" value={key}  onClick={()=>updateAvatarMaleHair(key)} {...register("hair_color")} />
                                                }
                                               <label htmlFor={`male[${index}]`}>
                                                    <img src={process.env.PUBLIC_URL +  `img/${male_hair_color_obj[key]}` } width="56" alt="" title=""/>
                                                </label>
                                            </div>
                                        ))}     
                                    </div>
                                    :
                                    <div className="form-row-right hairs-color color-options" >
                                        {Object.keys(female_hair_color_obj).map((key,index)=>(
                                            <div className="radio-tick" key={index}>
                                                {avatar.hair_color === key 
                                                ?
                                                <input  type="radio" id={`female[${index}]`} name="hair_color" value={key}  onClick={()=>updateAvatarFemaleHair(key)} {...register("hair_color")} />
                                                :
                                                <input  type="radio" id={`female[${index}]`} name="hair_color" value={key}  onClick={()=>updateAvatarFemaleHair(key)} {...register("hair_color")} />
                                                }
                                                <label htmlFor={`female[${index}]`}>
                                                    <img src={process.env.PUBLIC_URL +  `img/${female_hair_color_obj[key]}` } width="56" alt="" title=""/>
                                                </label>
                                            </div>
                                        ))}     
                                    </div>
                                    }
                                    


                                </div>

                                <div className="form-step-row">
                                    <div className="form-row-left">
                                        <label>Choose Clothes</label>
                                    </div>

                                    <div className="form-row-right clothe-color color-options">
                                        {Object.keys(dress).map((key,index)=>(
                                            <div className="radio-tick mr-3 selected" key={index}>
                                                {avatar.dress_color === key
                                                ?
                                                <input  type="radio" id={`clother[${index}]`} name="dress_color" value={key}  onClick={()=>updateAvatarDress(key)} {...register("dress_color")}/>
                                                :
                                                <input  type="radio" id={`clother[${index}]`} name="dress_color" value={key}  onClick={()=>updateAvatarDress(key)} {...register("dress_color")}/>

                                                }
                                                <label htmlFor={`clother[${index}]`}>
                                                    <img src={process.env.PUBLIC_URL + `img/${dress[key]}` } width="52" alt="" title="" />
                                                </label>
                                            </div>
                                         ))}
                                    </div>

                                </div>
                            </div>  

                            {/* <div className="form-step-row " id="profile_picture">
                                <div className="form-row-left">
                                    <label>Upload Picture</label>
                                </div>

                                <div id="profile_div" >
                                    <input type="file" name="profile_photo" id="profile_photo" />
                                </div>
                            </div> */}

                         

                            <div className="form-step-row last">
                                <div className="form-row-left">
                                </div>

                                <div className="form-row-right">
                                    <input type="submit" className="btn btn-primary"  value="Finish"/>
                                </div>
                            </div>
                        </form>
                    </div>

                    {/* <div className="col-lg-6 avatar-col d-none"id="profile_picture_avatar">
                        <div className="your-avatar mediator-male" >
                        <h4>Your Avatar</h4>
                        <div style="padding-top:30px;">
                           
                            <img src="#" style="
                            width: 150px;height: 150px;border-radius: 50%;vertical-align: middle;"/>
                            
                           
                            
                        </div>
                        </div>
                    </div> */}


                    <div className="col-lg-6 avatar-col" id="animated_avatar">
                        {avatar.gender === "male"  ?
                        <div className="your-avatar mediator-male" id="avatar-male">
                            <h4>Your Avatar</h4>
                            <p className="d-none">Not choosen</p>
                            <div className="avatar">
                                <div className="hair">
                                    {maleHair ?
                                    <img id="selected_hair" src={ process.env.PUBLIC_URL+`img/${male_hair_color_obj[maleHair]}` } width="73" alt="" title="" />
                                    :
                                    <img id="selected_hair" src={ avatar.hair_color ?  process.env.PUBLIC_URL+`img/${male_hair_color_obj[avatar.hair_color]}`:""} width="73" alt="" title="" />

                                    }
                                    {/* <img id="selected_hair" src={process.env.PUBLIC_URL+'img/male-hair-color-1.png'} width="73" alt="" title="" /> */}
                                </div>
                                <div className="face">
                                    {skin ? 
                                    <img id="selected_skin" src={ process.env.PUBLIC_URL+`img/${skin_color_obj[skin]}` } width="54" alt="" title="" />
                                    :
                                    <img id="selected_skin" src={avatar.skin_tone ? process.env.PUBLIC_URL+`img/${skin_color_obj[avatar.skin_tone]}`: process.env.PUBLIC_URL+`img/${skin_color_obj[skin]}` } width="54" alt="" title="" />
                                    }

                                </div> 
                                <div className="body">
                                    {dress_color ?
                                    <img id="selected_clothe" src={ process.env.PUBLIC_URL+`img/${dress[dress_color]}` } width="92" alt="" title="" />
                                    :
                                    <img id="selected_clothe" src={avatar.dress_color ? process.env.PUBLIC_URL+`img/${dress[avatar.dress_color]}`: process.env.PUBLIC_URL+`img/${dress[dress_color]}` } width="92" alt="" title="" />
                                    }
                                    {/* <img id="selected_clothe" src={process.env.PUBLIC_URL+'img/clothe-color-1.png'} width="92" alt="" title="" /> */}
                                </div>
                            </div>
                          
                        </div>
                        :
                        <div className="your-avatar mediator-female" id="avatar-female">
                        <h4>Your Avatar</h4>
                        <p className="d-none">Not choosen</p>
                        <div className="avatar">
                            <div className="hair">
                                {femaleHair ?
                                <img id="selected_hair" src={ process.env.PUBLIC_URL+`img/${female_hair_color_obj[femaleHair]}` } width="69" alt="" title="" />
                                :
                                <img id="selected_hair" src={ avatar.hair_color ?  process.env.PUBLIC_URL+`img/${female_hair_color_obj[avatar.hair_color]}`:""} width="69" alt="" title="" />

                                }
                                {/* <img id="selected_hair" src={process.env.PUBLIC_URL+'img/male-hair-color-1.png'} width="73" alt="" title="" /> */}
                            </div>
                            <div className="face">
                                {skin ? 
                                <img id="selected_skin" src={ process.env.PUBLIC_URL+`img/${skin_color_obj[skin]}` } width="54" alt="" title="" />
                                :
                                <img id="selected_skin" src={avatar.skin_tone ? process.env.PUBLIC_URL+`img/${skin_color_obj[avatar.skin_tone]}`: process.env.PUBLIC_URL+`img/${skin_color_obj[skin]}` } width="54" alt="" title="" />
                                }

                                {/* <img id="selected_skin" src={process.env.PUBLIC_URL+'img/skin-color-1.png'} width="54" alt="" title="" /> */}
                            </div> 
                            <div className="body">
                                {dress_color ?
                                <img id="selected_clothe" src={ process.env.PUBLIC_URL+`img/${dress[dress_color]}` } width="92" alt="" title="" />
                                :
                                <img id="selected_clothe" src={avatar.dress_color ? process.env.PUBLIC_URL+`img/${dress[avatar.dress_color]}`: process.env.PUBLIC_URL+`img/${dress[dress_color]}` } width="92" alt="" title="" />
                                }
                                {/* <img id="selected_clothe" src={process.env.PUBLIC_URL+'img/clothe-color-1.png'} width="92" alt="" title="" /> */}
                            </div>
                        </div>
                      
                    </div>
                    }



                        {/* <div className="your-avatar mediator-female d-none" id="avatar-female">
                            <h4>Your Avatar</h4>
                            <p className="d-none">Not choosen</p>
                             <div className="avatar">
                               <div className="hair">
                                        <img  id="selected_hair1" src={process.env.PUBLIC_URL+'img/male-hair-color-1.png'} width="69" alt="" title="" />
                                </div>
                                <div className="face">
                                        <img  id="selected_skin1" src={process.env.PUBLIC_URL+'img/skin-color-1.png'} width="54" alt="" title="" />
                                </div>
                                <div className="body">
                                    <img  id="selected_clothe1" src={process.env.PUBLIC_URL+'img/clothe-color-1.png'} width="92" alt="" title="" />
                                </div>
                            </div>
                        </div> */}

                    </div>
                </div>
            </div>
        </div>
    </div>
    
        </div>
        }
        </>
    );
}

export default CreateAvatar;